@let skills = skillRatings().controls;

<rt-box layout-vertical margin-bottom-small>
  <div margin-bottom-small>
    <rt-heading variant="heading large block">
      {{ 'app.interview.skills_section.heading' | translate }}
      <rt-badge color="counter-default" [text]="skills.length" margin-left-small-x />
    </rt-heading>
    <div>
      {{ 'app.interview.skills_section.subheading' | translate }}
    </div>
  </div>

  @for (skill of skills; track skill.controls.skillId.value) {
    <rt-evaluation-question-card
      [title]="skill.controls.skillName.value"
      [hint]="skill.controls.skillDescription.value ?? ''"
      [required]="required()"
      [control]="skill.controls.proficiencyId"
      [showValidationErrors]="showValidationErrors()"
      [attr.data-evaluation-invalid]="skill.controls.proficiencyId.invalid ? '' : null"
    >
      <rt-evaluation-single-choice-field
        [control]="skill.controls.proficiencyId"
        [options]="skill.controls.options.value"
      />
    </rt-evaluation-question-card>
  }
</rt-box>
